// extracted by mini-css-extract-plugin
export default {"gridHeader":"_1uZxk","name":"_1hEX3","icon":"_1IPNG","gridColumnsHeader":"_2TtAe"};